module.exports = window.DOMPurify || (window.DOMPurify = require('dompurify').default || require('dompurify'));


//////////////////
// WEBPACK FOOTER
// ./node_modules/isomorphic-dompurify/browser.js
// module id = 1727
// module chunks = 11